<app-side-dialog [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <h2>{{ title() }}</h2>
  </div>

  <div dialogContent class="flex flex-col">
    <form [formGroup]="form" class="flex flex-col h-full custom-form" (ngSubmit)="onSaveClick()">
      <div class="flex-1 min-h-0 overflow-y-auto flex flex-col gap-6">
        <app-date-time-range-fields [form]="form.controls.dates" [floatingLabels]="true" />

        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.admin.news.dialog.languageLabel' | translate }}</mat-label>
          <mat-select formControlName="languageCode">
            @for (language of languageOptions; track language) {
              <mat-option [value]="language">
                {{ 'pages.profile.language.' + (language === ELanguage.de ? 'german' : 'english') | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error [control]="form.get('languageCode')" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.admin.news.dialog.priorityLabel' | translate }}</mat-label>
          <input matInput type="number" formControlName="priority" [min]="0" [max]="255" />
          <mat-error [control]="form.get('priority')" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.admin.news.dialog.titleLabel' | translate }}</mat-label>
          <input matInput formControlName="title" />
          <mat-error [control]="form.get('title')" />
        </mat-form-field>

        <div
          class="flex flex-col message-field"
          [class.ql-invalid]="form.get('message')?.invalid && form.get('message')?.touched"
        >
          <quill-editor
            class="custom-quill-editor admin-news-message-editor"
            formControlName="message"
            [placeholder]="'pages.admin.news.dialog.messageLabel' | translate"
          />

          @if (form.get('message')?.touched) {
            <mat-error [control]="form.get('message')" />
          } @else {
            <div class="h-[21px]"></div>
          }
        </div>
      </div>

      <div class="sticky bottom-0 pt-4 pb-0.5 z-10 bg-shikenso-base-white flex flex-col gap-4">
        <hr class="border-shikenso-purple-base-12" />

        <div class="flex justify-end gap-3">
          <button mat-button type="button" [disabled]="submitLoading()" (click)="onCloseClick()">
            {{ 'shared.cancel' | translate }}
          </button>

          <button mat-flat-button color="primary" type="submit" [disabled]="submitLoading()">
            <p [class.hidden]="submitLoading()">{{ 'shared.save' | translate }}</p>

            @if (submitLoading()) {
              <app-dots-spinner />
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</app-side-dialog>
